<template>
  <div class="warning-wrapper">
    <strong>Insuring over $100,000 requires underwriter approval</strong>
    <p>Please complete your application. Within one business day, we will email you <strong>approved</strong> or <strong>rejected</strong> and ask if you would like to proceed with the transaction. For help call <a href="tel:617-302-7650">617-302-7650</a> or email <a href="mailto:dm3@dremca.com">dm3@dremca.com</a>.</p>
  </div>
</template>
<script>
export default {
  name: "Warning",
}
</script>
<style lang="scss" scoped>
@import "~@/style/_variables.scss";
.warning-wrapper {
  background-color: $yellow-light;
  padding: $padding-lg;
  border-radius: $border-radius-lg;
  p, strong {
    color: $yellow-dark;
  }
  p {
    margin: $padding-lg 0 0;
    line-height: 1.5;
  }
}
</style>